import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { Container, Form, Button, Alert } from "react-bootstrap/";

function ForgotPassword() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  //const EMAIL_URL = process.env.EMAIL_APP_URL + "/carnet/reset.php?email=";
  const EMAIL_URL = "https://federacionaikikaiargentina.ar/carnet/reset.php?email=";
  const search = useLocation().search;
  const paramEmail = new URLSearchParams(search).get("email");

  const [email, setEmail] = useState(paramEmail);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageDetail, setErrorMessageDetail] = useState("");
  const [isLoading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .get(EMAIL_URL + email)
      .then((res) => {
        console.log(res);
        history.push("/");
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error with forgot password:", error.response);
        setErrorMessage("Hubo un error, intente nuevamente.");
        const { status, name, message } = error.response.data.error;
        setErrorMessageDetail(`(${status}) ${message}`);
      });
  };
  
  const handleSubmitOld = async (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(API_URL + "/auth/forgot-password", {
        email: email,
      })
      .then((res) => {
        console.log(res);
        history.push("/");
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error with forgot password:", error.response);
        setErrorMessage("Hubo un error, intente nuevamente.");
        const { status, name, message } = error.response.data.error;
        setErrorMessageDetail(`(${status}) ${message}`);
      });
  };

  return (
    <Container
      id="main-container"
      className="p-3 mb-4 d-grid h-100 bg-light rounded-3"
    >
      <p>
        A continuación ingrese su email y recibirá un link para poder cambiar su
        contraseña.
      </p>
      <Form
        id="sign-in-form"
        className="text-center w-100"
        onSubmit={(e) => handleSubmit(e)}
      >
        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            size="lg"
            type="email"
            placeholder="Email"
            defaultValue={paramEmail}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="submit" disabled={isLoading}>
          {isLoading ? "Procesando…" : "Reiniciar contraseña"}
        </Button>
        {errorMessage ? (
          <Alert className="mt-3" variant="danger">
            <Alert.Heading>{errorMessage}</Alert.Heading>
            <p>{errorMessageDetail}</p>
          </Alert>
        ) : (
          <></>
        )}
      </Form>
      <p style={{ marginTop: "20px" }}>
        En caso de que no reciba el email comunicarse al email{" "}
        <a href="mailto:faadatoscarnet@gmail.com">faadatoscarnet@gmail.com</a>{" "}
        indicando DNI e email usado.
      </p>
    </Container>
  );
}
export default ForgotPassword;
